import React, { memo, useCallback, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { TouchableOpacity, View } from 'react-native';
import { Icon, theme } from '@sg/garnish';

import { CustomizationRestrictionModal } from '../CustomizationModals';

// ─────────────────────────────────────────────────────────────────────────────

export const CustomizationIngredientNotice = memo((props: Props) => {
  const { notice, ingredientName } = props;

  const { formatMessage } = useIntl();

  // ─── State ───────────────────────────────────────────────────────────

  const [isModalOpen, setIsModalOpen] = useState(false);

  // ─── Helpers ─────────────────────────────────────────────────────────

  const openModal = useCallback(() => {
    setIsModalOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  // ─────────────────────────────────────────────────────────────────────

  return (
    <View>
      <TouchableOpacity
        onPress={openModal}
        accessibilityRole="button"
        accessibilityLabel={formatMessage(messages.toggleLabel, {
          name: ingredientName,
        })}
        activeOpacity={0.7}
      >
        <Icon name="IconAlert" color={theme.colors.CAUTION} />
      </TouchableOpacity>

      <CustomizationRestrictionModal
        visible={isModalOpen}
        onRequestClose={closeModal}
        accessibilityLabel={formatMessage(messages.modalTitle, {
          name: ingredientName,
        })}
        restrictionText={notice}
      />
    </View>
  );
});

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  modalTitle: {
    defaultMessage: 'Dietary restrictions for {name}',
    description:
      'Customization | Ingredient notice | Restriction modal | Title',
  },
  toggleLabel: {
    defaultMessage: 'Open dietary restrictions details for {name}',
    description: 'Customization | Ingredient notice | Toggle label',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  ingredientName: string;
  notice: string;
};
